import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface CookieState {
  hasConsented: boolean | null;
  setConsent: (consent: boolean) => void;
}

export const useCookieStore = create<CookieState>()(
  persist(
    (set) => ({
      hasConsented: null,
      setConsent: (consent) => set({ hasConsented: consent }),
    }),
    {
      name: 'cookie-preferences',
    }
  )
);